import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { trigger, transition, query, stagger, animate, style } from '@angular/animations';
import * as i2 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
function CtaButtonComponent_div_0_cap_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-button", 6);
    i0.ɵɵlistener("onClick", function CtaButtonComponent_div_0_cap_button_2_Template_cap_button_onClick_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r5);
      const menuItem_r3 = restoredCtx.$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.executeCallback(menuItem_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menuItem_r3 = ctx.$implicit;
    i0.ɵɵproperty("label", menuItem_r3.label)("icon", menuItem_r3.icon);
  }
}
function CtaButtonComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, CtaButtonComponent_div_0_cap_button_2_Template, 1, 2, "cap-button", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "cap-button", 5);
    i0.ɵɵlistener("onClick", function CtaButtonComponent_div_0_Template_cap_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.handleCtaButtonClick());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@listAnimation", ctx_r0.displayedMenuItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.displayedMenuItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", ctx_r0.ctaButtonIcon);
  }
}
function CtaButtonComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function CtaButtonComponent_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.handleCtaButtonClick());
    });
    i0.ɵɵelementEnd();
  }
}
let CtaButtonComponent = /*#__PURE__*/(() => {
  class CtaButtonComponent {
    constructor() {
      this.showMenuItems = false;
      this.ctaButtonIcon = 'fas fa-ellipsis-v';
      this.displayedMenuItems = [];
      this._menuItems = [];
    }
    get menuItems() {
      return this._menuItems;
    }
    set menuItems(value) {
      this._menuItems = value;
      if (value.length === 1) {
        this.ctaButtonIcon = value[0].icon;
      }
    }
    handleCtaButtonClick() {
      if (this.menuItems.length > 1) {
        if (this.showMenuItems) {
          this.hideMenuItems();
        } else {
          this.displayMenuItems();
        }
      } else if (this.menuItems.length === 1) {
        this.menuItems[0].callback();
      }
    }
    executeCallback(item) {
      item.callback();
      this.hideMenuItems();
    }
    hideMenuItems() {
      this.showMenuItems = false;
      this.displayedMenuItems = [];
    }
    displayMenuItems() {
      this.showMenuItems = true;
      this.displayedMenuItems = this.menuItems;
    }
    static {
      this.ɵfac = function CtaButtonComponent_Factory(t) {
        return new (t || CtaButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CtaButtonComponent,
        selectors: [["cap-cta-button"]],
        inputs: {
          menuItems: "menuItems"
        },
        decls: 2,
        vars: 2,
        consts: [["class", "cta-container", 4, "ngIf"], ["class", "cta-blur-overlay", 3, "click", 4, "ngIf"], [1, "cta-container"], [1, "cta-menu-items"], ["class", "cta-menu-item", "styleClass", "primary", 3, "label", "icon", "onClick", 4, "ngFor", "ngForOf"], ["styleClass", "primary", 1, "cta-button", 3, "icon", "onClick"], ["styleClass", "primary", 1, "cta-menu-item", 3, "label", "icon", "onClick"], [1, "cta-blur-overlay", 3, "click"]],
        template: function CtaButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CtaButtonComponent_div_0_Template, 4, 3, "div", 0);
            i0.ɵɵtemplate(1, CtaButtonComponent_div_1_Template, 1, 0, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.menuItems.length);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showMenuItems);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i2.CapturumButtonComponent],
        styles: ["cap-button.cta-button .p-button.cap-button{border-radius:50%;padding:0;font-size:21px;width:55px;height:55px}.cta-container{position:relative;z-index:99999}.cta-menu-items{position:absolute;bottom:55px;right:0;text-align:right;width:max-content}.cta-menu-items cap-button.cta-menu-item{display:block;margin-bottom:15px}.cta-menu-items cap-button.cta-menu-item .p-button.cap-button{border-radius:15px}.cta-blur-overlay{-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);z-index:99998;position:fixed;inset:0}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('listAnimation', [transition('* => *', [query(':leave', [stagger(50, [animate('0.1s', style({
            opacity: 0,
            transform: 'translateY(100%)'
          }))])], {
            optional: true
          }), query(':enter', [style({
            opacity: 0,
            transform: 'translateY(100%)'
          }), stagger(-50, [animate('0.1s', style({
            opacity: 1,
            transform: 'translateY(0%)'
          }))])], {
            optional: true
          })])])]
        },
        changeDetection: 0
      });
    }
  }
  return CtaButtonComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumCtaButtonModule = /*#__PURE__*/(() => {
  class CapturumCtaButtonModule {
    static {
      this.ɵfac = function CapturumCtaButtonModule_Factory(t) {
        return new (t || CapturumCtaButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumCtaButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CapturumButtonModule]
      });
    }
  }
  return CapturumCtaButtonModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumCtaButtonModule, CtaButtonComponent };
